export const learningTracks = [
  {
    id: 'data-analytics',
    name: 'Data Analytics',
    icon: '📊',
    category: 'Tech',
    description: 'Master SQL, Python, Tableau, and data storytelling to land a data analyst role.',
    duration: '16 weeks',
    difficulty: 'Beginner → Intermediate',
    outcome: 'Junior Data Analyst',
    salaryRange: '$65,000 – $95,000',
    color: 'bg-blue-500',
    hex: '#3b82f6',
    gradient: 'from-blue-500 to-indigo-600',
    lightGradient: 'from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20',
    skills: ['SQL', 'Excel', 'Python', 'Tableau', 'Statistics', 'Data Viz'],
    jobs: 2847,
    popular: true,
    tag: 'Most Popular',
    tagColor: 'bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300',
    weeks: 16,
    enrolledCount: 12840,
    rating: 4.8,
  },
  {
    id: 'web-development',
    name: 'Web Development',
    icon: '💻',
    category: 'Tech',
    description: 'Build modern responsive websites and web apps with HTML, CSS, JavaScript, and React.',
    duration: '20 weeks',
    difficulty: 'Beginner → Intermediate',
    outcome: 'Junior Web Developer',
    salaryRange: '$70,000 – $110,000',
    color: 'bg-violet-500',
    hex: '#8b5cf6',
    gradient: 'from-violet-500 to-purple-600',
    lightGradient: 'from-violet-50 to-purple-50 dark:from-violet-900/20 dark:to-purple-900/20',
    skills: ['HTML/CSS', 'JavaScript', 'React', 'Node.js', 'Git', 'REST APIs'],
    jobs: 4200,
    popular: true,
    tag: 'High Demand',
    tagColor: 'bg-violet-100 dark:bg-violet-900/40 text-violet-700 dark:text-violet-300',
    weeks: 20,
    enrolledCount: 18500,
    rating: 4.9,
  },
  {
    id: 'python-ml',
    name: 'Python & Machine Learning',
    icon: '🤖',
    category: 'AI/ML',
    description: 'Learn Python and build ML models. Understand how AI works — and stay ahead of it.',
    duration: '24 weeks',
    difficulty: 'Intermediate',
    outcome: 'ML Engineer / Data Scientist',
    salaryRange: '$90,000 – $140,000',
    color: 'bg-emerald-500',
    hex: '#10b981',
    gradient: 'from-emerald-500 to-teal-600',
    lightGradient: 'from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20',
    skills: ['Python', 'NumPy', 'Pandas', 'Scikit-learn', 'TensorFlow', 'NLP'],
    jobs: 1950,
    popular: true,
    tag: 'AI Era',
    tagColor: 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300',
    weeks: 24,
    enrolledCount: 9200,
    rating: 4.7,
  },
  {
    id: 'ux-design',
    name: 'UI/UX Design',
    icon: '🎨',
    category: 'Design',
    description: 'Design beautiful, user-centered digital products with Figma and design thinking.',
    duration: '12 weeks',
    difficulty: 'Beginner',
    outcome: 'Junior UI/UX Designer',
    salaryRange: '$55,000 – $90,000',
    color: 'bg-pink-500',
    hex: '#ec4899',
    gradient: 'from-pink-500 to-rose-500',
    lightGradient: 'from-pink-50 to-rose-50 dark:from-pink-900/20 dark:to-rose-900/20',
    skills: ['Figma', 'Design Thinking', 'Prototyping', 'User Research', 'Wireframing'],
    jobs: 1650,
    popular: false,
    tag: 'Creative',
    tagColor: 'bg-pink-100 dark:bg-pink-900/40 text-pink-700 dark:text-pink-300',
    weeks: 12,
    enrolledCount: 7800,
    rating: 4.8,
  },
  {
    id: 'digital-marketing',
    name: 'Digital Marketing',
    icon: '📱',
    category: 'Business',
    description: 'Master SEO, paid ads, content marketing, and analytics to grow brands online.',
    duration: '10 weeks',
    difficulty: 'Beginner',
    outcome: 'Digital Marketing Specialist',
    salaryRange: '$45,000 – $75,000',
    color: 'bg-orange-500',
    hex: '#f97316',
    gradient: 'from-orange-500 to-amber-500',
    lightGradient: 'from-orange-50 to-amber-50 dark:from-orange-900/20 dark:to-amber-900/20',
    skills: ['SEO', 'Google Ads', 'Social Media', 'Analytics', 'Content Strategy'],
    jobs: 3200,
    popular: false,
    tag: 'Quick Start',
    tagColor: 'bg-orange-100 dark:bg-orange-900/40 text-orange-700 dark:text-orange-300',
    weeks: 10,
    enrolledCount: 15400,
    rating: 4.6,
  },
  {
    id: 'cybersecurity',
    name: 'Cybersecurity',
    icon: '🔐',
    category: 'Tech',
    description: 'Protect systems and networks. Learn security fundamentals, threat analysis, and defense.',
    duration: '18 weeks',
    difficulty: 'Intermediate',
    outcome: 'Security Analyst',
    salaryRange: '$75,000 – $120,000',
    color: 'bg-rose-600',
    hex: '#e11d48',
    gradient: 'from-rose-600 to-red-700',
    lightGradient: 'from-rose-50 to-red-50 dark:from-rose-900/20 dark:to-red-900/20',
    skills: ['Networking', 'Linux', 'Security+', 'Incident Response', 'SIEM', 'Ethical Hacking'],
    jobs: 1200,
    popular: false,
    tag: 'Growing Fast',
    tagColor: 'bg-rose-100 dark:bg-rose-900/40 text-rose-700 dark:text-rose-300',
    weeks: 18,
    enrolledCount: 5600,
    rating: 4.7,
  },
  {
    id: 'business-analytics',
    name: 'Business Analytics',
    icon: '📈',
    category: 'Business',
    description: 'Turn business data into decisions using Excel, Power BI, and strategic analysis.',
    duration: '12 weeks',
    difficulty: 'Beginner',
    outcome: 'Business Analyst',
    salaryRange: '$60,000 – $95,000',
    color: 'bg-indigo-500',
    hex: '#6366f1',
    gradient: 'from-indigo-500 to-blue-600',
    lightGradient: 'from-indigo-50 to-blue-50 dark:from-indigo-900/20 dark:to-blue-900/20',
    skills: ['Excel', 'Power BI', 'SQL', 'Business Strategy', 'Reporting', 'KPIs'],
    jobs: 2400,
    popular: false,
    tag: 'Versatile',
    tagColor: 'bg-indigo-100 dark:bg-indigo-900/40 text-indigo-700 dark:text-indigo-300',
    weeks: 12,
    enrolledCount: 11200,
    rating: 4.7,
  },
  {
    id: 'custom',
    name: 'Custom Path',
    icon: '✨',
    category: 'Custom',
    description: 'Tell our AI your exact learning goal. We build a personalized step-by-step plan just for you.',
    duration: 'Flexible',
    difficulty: 'Any Level',
    outcome: 'Your Goal',
    salaryRange: 'Depends on Goal',
    color: 'bg-brand-500',
    hex: '#4f46e5',
    gradient: 'from-brand-500 to-violet-600',
    lightGradient: 'from-brand-50 to-violet-50 dark:from-brand-900/20 dark:to-violet-900/20',
    skills: [],
    jobs: 0,
    popular: false,
    tag: 'AI-Generated',
    tagColor: 'bg-brand-100 dark:bg-brand-900/40 text-brand-700 dark:text-brand-300',
    weeks: 12,
    enrolledCount: null,
    rating: null,
  },
];

// Generic schedule activities for non-data-analytics tracks
export const generateTrackActivities = (track, weekOffset, dayIndex) => {
  const skills = track.skills;
  if (!skills.length) {
    return {
      morning: `Study Session ${weekOffset + 1} — Morning Focus`,
      evening: `Practice & Review — Day ${dayIndex}`,
    };
  }

  const weeksPerSkill = Math.max(2, Math.floor(track.weeks / skills.length));
  const skillIndex = Math.min(Math.floor(weekOffset / weeksPerSkill), skills.length - 1);
  const skill = skills[skillIndex];
  const isFirstHalf = (weekOffset % weeksPerSkill) < Math.ceil(weeksPerSkill / 2);

  const morningActivities = [
    `${skill} — Core Concepts & Theory`,
    `${skill} — Fundamentals Deep Dive`,
    `${skill} — Key Principles & Methods`,
    `${skill} — Advanced Techniques`,
    `${skill} — Best Practices & Patterns`,
  ];

  const eveningActivities = [
    `${skill} — Guided Practice Exercises`,
    `${skill} — Hands-On Project Work`,
    `${skill} — Real-World Application`,
    `${skill} — Problem Solving & Review`,
    `${skill} — Portfolio Project`,
  ];

  const idx = (weekOffset * 5 + dayIndex) % 5;
  return {
    morning: isFirstHalf ? morningActivities[idx % 3] : morningActivities[3 + (idx % 2)],
    evening: isFirstHalf ? eveningActivities[idx % 3] : eveningActivities[3 + (idx % 2)],
  };
};

// Generic module colors for non-data-analytics tracks
export const getTrackModuleColors = (track) => {
  const colorMaps = {
    'web-development': ['bg-violet-500', 'bg-purple-500', 'bg-indigo-500', 'bg-blue-500'],
    'python-ml': ['bg-emerald-500', 'bg-teal-500', 'bg-cyan-500', 'bg-green-500'],
    'ux-design': ['bg-pink-500', 'bg-rose-500', 'bg-fuchsia-500', 'bg-purple-500'],
    'digital-marketing': ['bg-orange-500', 'bg-amber-500', 'bg-yellow-500', 'bg-orange-600'],
    'cybersecurity': ['bg-rose-600', 'bg-red-600', 'bg-red-700', 'bg-rose-700'],
    'business-analytics': ['bg-indigo-500', 'bg-blue-500', 'bg-blue-600', 'bg-indigo-600'],
    'custom': ['bg-brand-500', 'bg-violet-500', 'bg-purple-500', 'bg-indigo-500'],
  };
  return colorMaps[track.id] || ['bg-slate-500'];
};
